import React, {useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {currentResource} from '../../../../../../../util/utils';
import {useDocumentId, useCanvasFormMetadata} from '../../../../../../../util/customHooks';
import {getControlById} from '../../../../../../../selectors/ISA315/selectors';
import StyledBodySpecialAccordionContentListItem from '../StyledBodySpecialAccordionContentListItem';
import StyledBodySpecialGridPrimaryColumn from '../StyledBodySpecialGridPrimaryColumn';
import Ellipses from '../../../../../EllipsesControl/EllipsesPresets';
import CreateEditControlModalWrapper from '../../../../../../Common/EntityCrud/CreateEditControlModalWrapper';

function ISA315ItAppScotAccordionControlsItem({controlId, bodyId}) {
	const control = useSelector((state) => getControlById(state, controlId));

	const [showModal, setShowModal] = useState(false);
	const documentId = useDocumentId();

	const {isShared, isTargetEngagement} = useCanvasFormMetadata();

	const controlType = useMemo(() => {
		return control.controlTypeId && control.controlTypeId <= Object.values(currentResource.controlTypeName).length
			? currentResource.controlTypeName[control.controlTypeId]
			: undefined;
	}, [control]);

	const onEditControlClick = () => {
		setShowModal(true);
	};

	return (
		<StyledBodySpecialAccordionContentListItem level={1}>
			<StyledControlName>
				<span className="styledControlNameText" onClick={onEditControlClick}>
					{control.controlName}
				</span>
			</StyledControlName>
			<WhiteSpace />
			<StyledLabelColumn>
				<Ellipses.Single>{controlType}</Ellipses.Single>
			</StyledLabelColumn>
			{showModal && (
				<CreateEditControlModalWrapper
					bodyId={bodyId}
					isEdit
					documentId={documentId}
					showModal={showModal}
					setShowModal={setShowModal}
					onClose={setShowModal}
					controlId={controlId}
					viewOnly={isShared && isTargetEngagement ? true : false}
				/>
			)}
		</StyledBodySpecialAccordionContentListItem>
	);
}

ISA315ItAppScotAccordionControlsItem.propTypes = {
	controlId: PropTypes.number.isRequired
};

export default ISA315ItAppScotAccordionControlsItem;

const StyledControlName = styled(StyledBodySpecialGridPrimaryColumn)`
	width: calc(100% - var(--px-300));
	.styledControlNameText {
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
		.ellipses {
			width: auto;
		}
	}
`;

const WhiteSpace = styled.section`
	width: var(--px-150);
`;

const StyledLabelColumn = styled.section`
	width: var(--px-150);
	font-weight: 100;
`;
